$(document).on('turbolinks:load', function(){
  $('.traceability-tooltip').tooltip({ boundary: 'window' })
});
